import { type ComponentsOverrides, type Theme } from '@mui/material/styles'

export const overridesSnackbar = (theme: Theme): ComponentsOverrides['MuiSnackbar'] => ({
  root: {
    color: theme.palette.text.primary,
    marginBottom: theme.spacing(4),
    [theme.breakpoints.down('sm')]: {
      left: theme.spacing(2),
      right: theme.spacing(2),
    },
  },
})
